<template>
  <div class="Rank">
    <div class="note" v-if="procedure == 3">
      <p>每日10点和18点更新积分和排行榜，如有疑问请联系客服微信</p>
      <!-- <img :src="qrcode" width="200"> -->
    </div>
    <div class="note fs20" v-if="procedure == 40">
      <p>金牌附加赛 1月25日上午10:00-10:30</p>
      <p v-if="final_tmp_passed">恭喜你晋级金牌附加赛，稍后请查看公告和短信。 </p>
      <p>1月27日可以查询奖项和证书</p>
    </div>
    <div class="group">
      <div class="grp fs20" :class="{focus: fcg==g.key }" v-for="g in groups" @click="focus(g.key)">{{g.text}}</div>
    </div>
    <my_table :infos="info" :titles="titles" :isRank="false" :rankLength="heroLength"></my_table>
  </div>
</template>

<script>
 import MyTable from '@/components/Table.vue'
 import QRCode from '@/assets/image/score/service_qr.png'
 import MyImage from '@/components/Image.vue'

 export default {
   name: 'RepRank',
   props: ['procedure'],
   computed: {
     qrcode() {
       return QRCode
     },
     user() {
       return this.$store.state.auth.user
     },
     titles() {
       return this.$store.state.score.finalRank.title
     },
     game_year() {
       return this.$store.state.game_slug.slice(0,4)
     },
     extra_ids () {
       return [1444,321,8285,408,643,8155,8077,8076,8329,18,269,8992,561]
     },
     final_tmp_passed() {
       if(this.user)
       return this.$store.state.auth.game_state[this.game_year+'-2'].state > 0 || this.extra_ids.indexOf(this.user.id) != -1
     },
     game_slug() {
       return this.$store.state.game_slug
     },
     groups() {
       return this.$store.state.enroll.groups
     },
     indexOfGroup() {
       return {
         's': 1,
         'm': 2,
         'l': 3,
         'I-p': '0:1',
         'I-m': '0:2',
         'II-p': '1:1',
         'II-m': '1:2'
       }
     },
     ranklen() {
       return {
         'I-p': 59,
         'I-m': 46,
         'II-p': 21,
         'II-m': 25
       }
     },
   },
   data () {
     return {
       fcg: 's',
       info: [],
       loaded: 0,
       sw: true,
       heroLength: -1,
     }
   },
   methods: {
     fetchData () {

       let round = this.game_slug.slice(0, -1) + '2'
       let uri = '/api/rank/final?round='+round +'&skip='+this.loaded+'&group='+this.indexOfGroup[this.fcg]
       this.loaded += 20;
       this.$http.get(uri)
           .then(res => {
             this.info = this.info.concat(res.data.map(d=>
               {return [d.rank, d.username, d.score, d.organization, d.area_name]}))
             this.heroLength = res.total * 0.3 | 0 + 1;
             if(res.data.length == 20)
               this.sw = true;
             })
     },
     focus(k) {
       this.fcg = k
       this.info = []
       this.loaded = 0
       this.fetchData()
     },
   },
   mounted() {
     this.sw=false
     this.fetchData()
     // 此处使用node做了代理
     // 注册scroll事件并监听
     
     window.addEventListener('scroll',() =>{
       let el = document.scrollingElement||document.documentElement;
       /* console.log(el.scrollTop)
        * console.log(0.7*(document.body.scrollHeight - window.innerHeight)) */
       if (el.scrollTop  >= 0.7*(document.body.scrollHeight - window.innerHeight)) {
         /* console.log('sw', this.sw); */
         /* 如果开关打开则加载数据 */
         if(this.sw){
           // 将开关关闭
           this.sw = false;
           this.fetchData();
         }
       }
     });
   },
   components: {
     my_table: MyTable,
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Rank{
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
   margin-top: 5vw;
   margin-bottom: 3.4vw;
 }
 .group{
   display: flex;
   align-items:center;
   justify-content: space-around;
   width: 50vw;
   border-bottom: 1px dashed black;
   margin-bottom: 1.5625vw;
 }
 .grp{
   line-height: 2.5vw;
 }
 .focus{
   border-bottom: 1px solid black;
   color: #4411FF;
 }
 .note{
   text-align: center;
   margin-bottom: 2vw;
   color: black;
 }
</style>
